import { render, staticRenderFns } from "./QuickQuestionComponent.vue?vue&type=template&id=94e4fdc6&scoped=true"
import script from "./QuickQuestionComponent.vue?vue&type=script&lang=ts"
export * from "./QuickQuestionComponent.vue?vue&type=script&lang=ts"
import style0 from "./QuickQuestionComponent.vue?vue&type=style&index=0&id=94e4fdc6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94e4fdc6",
  null
  
)

export default component.exports